import { cn } from '@/utils/tailwind';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-gr-300/90', className)} {...props} />;
}

export { Skeleton };
